import { IsNotEmpty, IsString, IsDateString } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

export class CreateSchoolYearDto {
  @ApiProperty({
    type: 'string',
    description: "Code de l'année scolaire",
    example: '2024-2025',
  })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    type: 'string',
    description: "Nom de l'année scolaire",
    example: 'Année 2024-2025',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiProperty({ type: 'string', description: 'Date de début', example: '2024-09-01' })
  @IsNotEmpty()
  @IsDateString()
  startDate!: Date

  @ApiProperty({ type: 'string', description: 'Date de fin', example: '2025-07-31' })
  @IsNotEmpty()
  @IsDateString()
  endDate!: Date
}
